import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { get, post } from "../../helpers/api_helper";
import { FLUSH_CACHE_URL } from "../../helpers/url_helper";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import 'react-drawer/lib/react-drawer.css';
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import logoLightSvg from "../../assets/images/logo-light.svg";
import logo from "../../assets/images/logo.svg";
import AdminApprovalsModal from "modules/Approvals/components/AdminApprovalsModal";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  changeSidebarType,
  showRightSidebarAction,
  toggleLeftmenu,
} from "../../store/actions";


const Header = () => {
  const [renewMessage, setRenewalMessage] = useState(false)
  const [days, setDays] = useState(0)

  const [isWpConnected, setIsWpConnected] = useState(false);
  const [liveTime, setLiveTime] = useState("");
  const [loggedInUser, setLoggedInUser] = useState("");
  const [userRole, setUserRole] = useState("");
  const [dueTodayCount, setDueTodayCount] = useState(0);
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [isApprovalsModalOpen, setIsApprovalsModalOpen] = useState(false);
  const [syncStatus, setSyncStatus] = useState("idle");
  const [isSyncModalOpen, setIsSyncModalOpen] = useState(false);
  const [syncMode, setSyncMode] = useState("range");
  const [customFromDate, setCustomFromDate] = useState(new Date().toLocaleDateString('en-CA'));
  const [customToDate, setCustomToDate] = useState(new Date().toLocaleDateString('en-CA'));
  const [syncResult, setSyncResult] = useState(null);
  const [isFlushingCache, setIsFlushingCache] = useState(false);
  const [flushSuccess, setFlushSuccess] = useState(false);
  const [isToolsDropdownOpen, setIsToolsDropdownOpen] = useState(false);

  const history = useHistory();
  const isOrdersPage = window.location.pathname === "/orders";

  const auth = (() => {
    try {
      return JSON.parse(localStorage.getItem("authUser")) || {};
    } catch (e) {
      return {};
    }
  })();
  const roleStr = (auth?.role || auth?.user_role || "").toLowerCase();
  const isAdmin = ["admin", "superadmin", "owner"].includes(roleStr) || auth?.username === "owner" || userRole === "admin";

  const capsuleStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '30px',
    fontSize: '12px',
    fontWeight: '600',
    height: '32px',
    border: '1px solid transparent',
  };

  const timeStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(42, 48, 66, 0.05)',
    borderColor: 'rgba(42, 48, 66, 0.1)',
    color: '#495057',
  };

  const wpConnectedStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(37, 211, 102, 0.1)',
    borderColor: 'rgba(37, 211, 102, 0.2)',
    color: '#198754',
  };

  const wpDisconnectedStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(220, 53, 69, 0.1)',
    borderColor: 'rgba(220, 53, 69, 0.2)',
    color: '#dc3545',
  };

  const dueTodayStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(239, 83, 80, 0.12)',
    borderColor: 'rgba(239, 83, 80, 0.25)',
    color: '#ef5350',
    display: 'inline-flex',
  };

  const syncSyncingStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(85, 110, 230, 0.1)',
    borderColor: 'rgba(85, 110, 230, 0.2)',
    color: '#556ee6',
    display: 'inline-flex',
    cursor: 'pointer',
  };

  const syncSyncedStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(37, 211, 102, 0.1)',
    borderColor: 'rgba(37, 211, 102, 0.2)',
    color: '#198754',
    display: 'inline-flex',
    cursor: 'pointer',
  };

  const syncFailedStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(220, 53, 69, 0.1)',
    borderColor: 'rgba(220, 53, 69, 0.2)',
    color: '#dc3545',
    display: 'inline-flex',
    cursor: 'pointer',
  };

  const approvalsCapsuleStyle = {
    ...capsuleStyle,
    backgroundColor: pendingApprovalsCount > 0 ? 'rgba(241, 180, 76, 0.18)' : 'rgba(85, 110, 230, 0.08)',
    borderColor: pendingApprovalsCount > 0 ? 'rgba(241, 180, 76, 0.4)' : 'rgba(85, 110, 230, 0.2)',
    color: pendingApprovalsCount > 0 ? '#b37400' : '#556ee6',
    cursor: 'pointer',
    display: 'inline-flex',
  };

  const userStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(85, 110, 230, 0.08)',
    borderColor: 'rgba(85, 110, 230, 0.15)',
    color: '#556ee6',
    textDecoration: 'none',
    cursor: 'pointer',
    maxWidth: '240px',
    display: 'inline-flex',
  };

  const flushCacheStyle = {
    ...capsuleStyle,
    backgroundColor: 'rgba(255, 159, 67, 0.12)',
    borderColor: 'rgba(255, 159, 67, 0.3)',
    color: '#d35400',
    cursor: 'pointer',
    display: 'inline-flex',
    transition: 'all 0.2s',
  };

  const handleFlushCache = async () => {
    if (isFlushingCache) return;
    try {
      if (isMountedRef.current) setIsFlushingCache(true);
      const res = await post(FLUSH_CACHE_URL, { module: 'all' });
      if (res && (res.status === 200 || res.status === true || res.success === true)) {
        if (isMountedRef.current) {
          setFlushSuccess(true);
          setTimeout(() => {
            if (isMountedRef.current) setFlushSuccess(false);
          }, 3000);
        }
        // Dispatch window event so components can refresh data immediately
        window.dispatchEvent(new CustomEvent('CACHE_FLUSHED'));
      }
    } catch (e) {
      console.error("Cache flush error:", e);
    } finally {
      if (isMountedRef.current) setIsFlushingCache(false);
    }
  };

  const handleLaunchScanPortal = async () => {
    try {
      const res = await get("/api/scanningortracking/access");
      if (res && res.status === 200 && res.response?.accessurl) {
        window.open(res.response.accessurl, "_blank");
      } else {
        window.open("https://scan.oralstop.com/pending-requests/?lab_code=dglab", "_blank");
      }
    } catch (e) {
      window.open("https://scan.oralstop.com/pending-requests/?lab_code=dglab", "_blank");
    }
  };

  const circleButtonStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #ced4da',
    backgroundColor: '#fff',
    color: '#495057',
    cursor: 'pointer',
    transition: 'all 0.2s',
  };

  const triggerNewOrder = () => {
    if (window.location.pathname === "/orders") {
      window.dispatchEvent(new CustomEvent('trigger-new-order'));
    } else {
      history.push("/orders?openNewOrder=true");
    }
  };

  const checkWpStatus = async () => {
    try {
      const res = await get("/api/notifications/whatsapp");
      if (res && res.status === 200) {
        setIsWpConnected(parseInt(res.response?.is_connected) === 1);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDueTodayCount = async () => {
    try {
      const res = await get("/api/orders/due_count");
      if (res && res.status === 200) {
        setDueTodayCount(res.response?.count || 0);
      }
    } catch (e) {
      console.error("Error fetching due orders count:", e);
    }
  };

  const isMountedRef = React.useRef(true);

  const triggerAttendanceSync = async (fromDate = null, toDate = null) => {
    try {
      if (isMountedRef.current) setSyncStatus("syncing");
      const todayStr = new Date().toLocaleDateString('en-CA');
      const payloadFrom = fromDate || todayStr;
      const payloadTo = toDate || todayStr;

      const res = await post("/api/hrms/attendance/sync", {
        from_date: payloadFrom,
        to_date: payloadTo
      });
      if (res && res.status === true) {
        if (isMountedRef.current) setSyncStatus("synced");
        return {
          success: true,
          processed: res.processed_records || 0,
          failed: res.failed_records || 0,
          total: res.total_raw_logs || 0
        };
      } else {
        if (isMountedRef.current) setSyncStatus("failed");
        return {
          success: false,
          message: res?.message || "Sync failed"
        };
      }
    } catch (e) {
      console.error("Attendance sync error:", e);
      if (isMountedRef.current) setSyncStatus("failed");
      return {
        success: false,
        message: e?.message || "Attendance sync error"
      };
    }
  };

  const handleManualSync = async () => {
    setSyncResult(null);
    let fromDate = "";
    let toDate = "";
    const today = new Date();

    if (syncMode === "range") {
      fromDate = customFromDate;
      toDate = customToDate;
    } else if (syncMode === "month") {
      const y = today.getFullYear();
      const m = today.getMonth();
      const firstDay = new Date(y, m, 1);
      fromDate = firstDay.toLocaleDateString('en-CA');
      toDate = today.toLocaleDateString('en-CA');
    } else if (syncMode === "all") {
      const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
      fromDate = threeMonthsAgo.toLocaleDateString('en-CA');
      toDate = today.toLocaleDateString('en-CA');
    }

    const result = await triggerAttendanceSync(fromDate, toDate);
    setSyncResult(result);
  };

  const fetchPendingApprovalsCount = async () => {
    try {
      const res = await get("/api/approvals/pending_count");
      if (res && res.status === 200) {
        setPendingApprovalsCount(res.response?.count || 0);
      }
    } catch (e) {
      // silent catch
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (localStorage.getItem('_top_bar') == "true") {
      setDays(localStorage.getItem('reminder'))
      setRenewalMessage(!renewMessage)
    }

    const auth = JSON.parse(localStorage.getItem("authUser"));
    if (auth && auth.username) {
      setLoggedInUser(auth.username);
    }
    const roleStr = (auth?.role || auth?.user_role || "").toLowerCase();
    const isAdmin = ["admin", "superadmin", "owner"].includes(roleStr) || auth?.username === "owner";
    setUserRole(isAdmin ? "admin" : roleStr);

    let wpInterval = null;
    let approvalsInterval = null;
    let syncInterval = null;

    if (isAdmin) {
      const safeFetchApprovals = async () => {
        try {
          const res = await get("/api/approvals/pending_count");
          if (isMounted && res && res.status === 200) {
            setPendingApprovalsCount(res.response?.count || 0);
          }
        } catch (e) {
          // silent catch
        }
      };

      const safeCheckWp = async () => {
        try {
          const res = await get("/api/notifications/whatsapp");
          if (isMounted) {
            const isConn = Boolean(res && res.status === 200 && (res.response?.is_connected == 1 || res.response?.is_connected === true));
            setIsWpConnected(isConn);
          }
        } catch (e) {
          if (isMounted) setIsWpConnected(false);
        }
      };

      safeCheckWp();
      wpInterval = setInterval(safeCheckWp, 60000);

      safeFetchApprovals();
      approvalsInterval = setInterval(safeFetchApprovals, 30000);

      triggerAttendanceSync();
      syncInterval = setInterval(triggerAttendanceSync, 300000);
    }

    const safeFetchDueToday = async () => {
      try {
        const res = await get('/api/orders/dueToday');
        if (isMounted && res && res.status === 200) {
          setDueTodayCount(res.response || 0);
        }
      } catch (e) {
        // silent catch
      }
    };

    safeFetchDueToday();
    const dueInterval = setInterval(safeFetchDueToday, 60000);

    const updateTime = () => {
      if (isMounted) {
        const date = new Date();
        setLiveTime(date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
      }
    };
    updateTime();
    const clockInterval = setInterval(updateTime, 1000);

    return () => {
      isMounted = false;
      isMountedRef.current = false;
      if (wpInterval) clearInterval(wpInterval);
      if (clockInterval) clearInterval(clockInterval);
      if (dueInterval) clearInterval(dueInterval);
      if (approvalsInterval) clearInterval(approvalsInterval);
      if (syncInterval) clearInterval(syncInterval);
    };
  }, [])

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        {
          renewMessage &&
          <div style={{ background: '#2a3042', color: '#fff', fontSize: '14px', padding: '5px', textAlign: 'center' }}>
            This is a friendly reminder that your subscription with us will expire in just  <b>{days}</b> {days > 1 ? 'days' : 'day'}. To ensure uninterrupted access to our services, please renew your subscription before the expiration date.
            <a alt="paynow" title="paynow" className="btn btn-primary ms-5" role="button" href='https://razorpay.com/payment-button/pl_LKsvl67l9KmI2x/view/?utm_source=payment_button&utm_medium=button&utm_campaign=payment_button' target='_blank' rel="noreferrer">PAY NOW</a>
            <i role="button" onClick={() => {
              setRenewalMessage(!renewMessage)
              localStorage.setItem('_top_bar', false)
            }} className='mdi mdi-close noti-icon pull-right' style={{ float: 'right', padding: '10px' }} />
          </div>
        }

        <div className="navbar-header">
          <div className="d-flex">

            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {(() => {
              let menus = null;
              try {
                const rawMenus = localStorage.getItem('menus');
                if (rawMenus) menus = JSON.parse(rawMenus);
              } catch (e) { }

              const canAddOrder = isAdmin || Boolean(menus?.orders?.orders?.add);
              const canAddClient = isAdmin || Boolean(menus?.client_master?.client?.add);
              const canAddOrderform = isAdmin || Boolean(menus?.orders?.orderform?.add);

              if (!canAddOrder && !canAddClient && !canAddOrderform) return null;

              const handleNewOrderClick = () => {
                if (window.location.pathname === "/orders") {
                  window.dispatchEvent(new CustomEvent("OPEN_ADD_ORDER"));
                } else {
                  history.push("/orders?action=new");
                }
              };

              const handleNewClientClick = () => {
                if (window.location.pathname === "/clients" || window.location.pathname === "/masters/clients") {
                  window.dispatchEvent(new CustomEvent("OPEN_ADD_CLIENT"));
                } else {
                  history.push("/clients?action=new");
                }
              };

              return (
                <div className="d-flex align-items-center ms-2 ms-xl-3 flex-shrink-0">
                  {canAddOrder && (
                    <button
                      type="button"
                      onClick={handleNewOrderClick}
                      className="btn btn-success btn-sm me-1 me-xl-2 d-flex align-items-center topbar-btn-compact"
                      style={{ fontWeight: "bold", padding: "5px 10px", borderRadius: "4px" }}
                      title="New Order"
                    >
                      <i className="bx bx-plus font-size-15 align-middle" />
                      <span className="topbar-btn-text ms-1">New Order</span>
                    </button>
                  )}
                  {canAddClient && (
                    <button
                      type="button"
                      onClick={handleNewClientClick}
                      className="btn btn-outline-primary btn-sm me-1 me-xl-2 d-flex align-items-center topbar-btn-compact"
                      style={{ fontWeight: "bold", padding: "5px 10px", borderRadius: "4px" }}
                      title="New Client"
                    >
                      <i className="bx bx-user-plus font-size-15 align-middle" />
                      <span className="topbar-btn-text ms-1">New Client</span>
                    </button>
                  )}
                  {canAddOrderform && (
                    <Link
                      to="/orderform/create"
                      className="btn btn-info btn-sm d-flex align-items-center topbar-btn-compact"
                      style={{ fontWeight: "bold", padding: "5px 10px", borderRadius: "4px", color: "#fff" }}
                      title="Create Orderform"
                    >
                      <i className="bx bx-file-blank font-size-15 align-middle" />
                      <span className="topbar-btn-text ms-1">Create Orderform</span>
                    </Link>
                  )}
                </div>
              );
            })()}
          </div>

          <div className="d-flex align-items-center pe-2 pe-xl-3 topbar-capsules-wrapper" style={{ height: '70px' }}>
            <style>{`
              @keyframes pulse-red {
                0% {
                  box-shadow: 0 0 0 0 rgba(239, 83, 80, 0.4);
                }
                70% {
                  box-shadow: 0 0 0 6px rgba(239, 83, 80, 0);
                }
                100% {
                  box-shadow: 0 0 0 0 rgba(239, 83, 80, 0);
                }
              }
              .capsule-pulse {
                animation: pulse-red 2s infinite;
              }
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
              .icon-spin {
                animation: spin 1.5s linear infinite;
              }
              .topbar-capsules-wrapper {
                display: flex;
                align-items: center;
                gap: 6px;
                flex-shrink: 0;
                min-width: 0;
              }
              @media (max-width: 1280px) {
                .topbar-btn-text {
                  display: none !important;
                }
                .capsule-compact {
                  padding: 3px 8px !important;
                  font-size: 11px !important;
                  height: 30px !important;
                }
                .capsule-text-hide {
                  display: none !important;
                }
              }
            `}</style>

            {/* UTILITY: Due Today Count */}
            {dueTodayCount > 0 && (
              <div className="ms-1 ms-xl-2">
                <div style={dueTodayStyle} className="capsule-pulse capsule-compact" title="Orders Due Today">
                  <i className="bx bx-calendar-exclamation font-size-15 me-1 align-middle" />
                  <span className="capsule-text-hide">Due: </span>{dueTodayCount}
                </div>
              </div>
            )}

            {/* UTILITY: Live Time */}
            <div className="topbar-clock ms-1 ms-xl-2 d-none d-xl-inline-flex">
              <div style={timeStyle} className="capsule-compact">
                <i className="bx bx-time-five me-1 font-size-15 align-middle text-primary" />
                {liveTime}
              </div>
            </div>

            {/* URGENT: Edit Approvals Center Alert (Visible when pending requests exist) */}
            {pendingApprovalsCount > 0 && (
              <div className="ms-1 ms-xl-2">
                <div
                  style={approvalsCapsuleStyle}
                  className="capsule-compact capsule-pulse"
                  title="Order & Invoice Edit Approval Center (Pending Requests)"
                  onClick={() => setIsApprovalsModalOpen(true)}
                >
                  <i className="mdi mdi-lock-alert font-size-15 align-middle text-warning" />
                  <span className="capsule-text-hide ms-1">Approvals</span>
                  <span className="badge bg-danger ms-1 rounded-pill">{pendingApprovalsCount}</span>
                </div>
              </div>
            )}

            {/* SECONDARY: Inline Capsules on Ultra-Wide Screens (>= 1440px / xxl) */}
            {['admin', 'superadmin', 'owner'].includes(userRole) && (
              <div className="ms-1 ms-xl-2 d-none d-xxl-inline-flex">
                <div style={isWpConnected ? wpConnectedStyle : wpDisconnectedStyle} className="capsule-compact" title={isWpConnected ? "WhatsApp Connected" : "WhatsApp Disconnected"}>
                  <i className="fab fa-whatsapp font-size-15 align-middle" />
                  <span className="capsule-text-hide ms-1">{isWpConnected ? "Connected" : "Disconnected"}</span>
                </div>
              </div>
            )}

            {['admin', 'superadmin', 'owner'].includes(userRole) && syncStatus !== "idle" && (
              <div className="ms-1 ms-xl-2 d-none d-xxl-inline-flex">
                {syncStatus === "syncing" && (
                  <div
                    style={syncSyncingStyle}
                    className="capsule-compact"
                    title="Syncing Biometric Attendance logs..."
                    onClick={() => { setIsSyncModalOpen(true); setSyncResult(null); }}
                  >
                    <i className="bx bx-sync font-size-15 align-middle icon-spin" />
                    <span className="capsule-text-hide ms-1">Syncing...</span>
                  </div>
                )}
                {syncStatus === "synced" && (
                  <div
                    style={syncSyncedStyle}
                    className="capsule-compact"
                    title="Biometric Attendance logs synced successfully"
                    onClick={() => { setIsSyncModalOpen(true); setSyncResult(null); }}
                  >
                    <i className="bx bx-check-double font-size-15 align-middle" />
                    <span className="capsule-text-hide ms-1">Synced</span>
                  </div>
                )}
                {syncStatus === "failed" && (
                  <div
                    style={syncFailedStyle}
                    className="capsule-compact"
                    title="Biometric Attendance sync failed"
                    onClick={() => { setIsSyncModalOpen(true); setSyncResult(null); }}
                  >
                    <i className="bx bx-error-circle font-size-15 align-middle" />
                    <span className="capsule-text-hide ms-1">Sync Error</span>
                  </div>
                )}
              </div>
            )}

            {pendingApprovalsCount === 0 && (['admin', 'superadmin', 'owner'].includes(userRole)) && (
              <div className="ms-1 ms-xl-2 d-none d-xxl-inline-flex">
                <div
                  style={approvalsCapsuleStyle}
                  className="capsule-compact"
                  title="Order & Invoice Edit Approval Center"
                  onClick={() => setIsApprovalsModalOpen(true)}
                >
                  <i className="mdi mdi-shield-check font-size-15 align-middle" />
                  <span className="capsule-text-hide ms-1">Approvals</span>
                </div>
              </div>
            )}

            {(isAdmin || ['admin', 'superadmin', 'owner'].includes(userRole)) && (
              <div className="ms-1 ms-xl-2 d-none d-xxl-inline-flex">
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '4px 10px',
                    borderRadius: '30px',
                    fontSize: '12px',
                    fontWeight: '700',
                    height: '32px',
                    border: '1px solid #bae6fd',
                    backgroundColor: '#f0f9ff',
                    color: '#0284c7',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                  className="capsule-compact"
                  title="Launch Oralstop Scanning & Tracking Portal"
                  onClick={handleLaunchScanPortal}
                >
                  <i className="bx bx-radar font-size-15 align-middle" style={{ color: '#0284c7' }} />
                  <span className="capsule-text-hide ms-1">Scan Portal</span>
                </div>
              </div>
            )}

            {(isAdmin || ['admin', 'superadmin', 'owner'].includes(userRole)) && (
              <div className="ms-1 ms-xl-2 d-none d-xxl-inline-flex">
                <div
                  style={flushCacheStyle}
                  className="capsule-compact"
                  title="Flush Redis Cache across all modules"
                  onClick={handleFlushCache}
                >
                  {isFlushingCache ? (
                    <>
                      <i className="bx bx-loader-alt font-size-15 align-middle icon-spin text-warning" />
                      <span className="capsule-text-hide ms-1">Flushing...</span>
                    </>
                  ) : flushSuccess ? (
                    <>
                      <i className="bx bx-check font-size-15 align-middle text-success" />
                      <span className="text-success capsule-text-hide ms-1">Flushed!</span>
                    </>
                  ) : (
                    <>
                      <i className="bx bx-bolt-circle font-size-15 align-middle text-warning" />
                      <span className="capsule-text-hide ms-1">Flush</span>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* SECONDARY: Dropdown for Compact / Standard Desktop Screens (< xxl / <= 1440px / zoom) */}
            {(isAdmin || ['admin', 'superadmin', 'owner'].includes(userRole)) && (
              <div className="ms-1 ms-xl-2 d-inline-flex d-xxl-none">
                <Dropdown
                  isOpen={isToolsDropdownOpen}
                  toggle={() => setIsToolsDropdownOpen(!isToolsDropdownOpen)}
                >
                  <DropdownToggle
                    tag="button"
                    className="btn btn-sm d-flex align-items-center"
                    style={{
                      ...capsuleStyle,
                      backgroundColor: 'rgba(85, 110, 230, 0.08)',
                      borderColor: 'rgba(85, 110, 230, 0.2)',
                      color: '#556ee6',
                      cursor: 'pointer'
                    }}
                    title="System Tools & Actions"
                  >
                    <i className="bx bx-grid-alt me-1 font-size-14 align-middle" />
                    <span>Tools</span>
                    <i className="mdi mdi-chevron-down ms-1 font-size-12 align-middle" />
                  </DropdownToggle>
                  <DropdownMenu right style={{ minWidth: '220px', zIndex: 1050, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                    <DropdownItem onClick={() => { setIsSyncModalOpen(true); setSyncResult(null); }}>
                      <i className={`bx ${syncStatus === 'syncing' ? 'bx-sync icon-spin' : syncStatus === 'synced' ? 'bx-check-double text-success' : 'bx-sync text-primary'} me-2 align-middle font-size-15`} />
                      Attendance Sync
                      <span className="badge bg-light text-dark ms-2 float-end">
                        {syncStatus === 'syncing' ? 'Syncing...' : syncStatus === 'synced' ? 'Synced' : syncStatus === 'failed' ? 'Error' : 'Sync'}
                      </span>
                    </DropdownItem>
                    <DropdownItem onClick={() => setIsApprovalsModalOpen(true)}>
                      <i className="mdi mdi-shield-check me-2 align-middle font-size-15 text-warning" />
                      Approvals Center
                      {pendingApprovalsCount > 0 && (
                        <span className="badge bg-danger ms-2 float-end rounded-pill">{pendingApprovalsCount}</span>
                      )}
                    </DropdownItem>
                    <DropdownItem onClick={handleLaunchScanPortal}>
                      <i className="bx bx-radar me-2 align-middle font-size-15 text-info" />
                      Scan Portal
                    </DropdownItem>
                    <DropdownItem onClick={handleFlushCache} disabled={isFlushingCache}>
                      <i className={`bx ${isFlushingCache ? 'bx-loader-alt icon-spin' : flushSuccess ? 'bx-check text-success' : 'bx-bolt-circle text-warning'} me-2 align-middle font-size-15`} />
                      {isFlushingCache ? 'Flushing Cache...' : flushSuccess ? 'Cache Flushed!' : 'Flush Cache'}
                    </DropdownItem>
                    {['admin', 'superadmin', 'owner'].includes(userRole) && <DropdownItem divider />}
                    {['admin', 'superadmin', 'owner'].includes(userRole) && (
                      <DropdownItem header className="d-flex align-items-center text-muted font-size-12 py-1">
                        <i className={`fab fa-whatsapp me-2 font-size-14 ${isWpConnected ? 'text-success' : 'text-danger'}`} />
                        WhatsApp: {isWpConnected ? 'Connected' : 'Disconnected'}
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}

            {/* UTILITY: Logged in User & Profile Link */}
            <div className="ms-1 ms-xl-2">
              <Link to="/settings/company" style={userStyle} className="capsule-compact" title={`Profile: ${loggedInUser || "USER"}`}>
                <i className="bx bx-user-circle font-size-15 align-middle" />
                <span className="text-truncate text-uppercase ms-1" style={{ maxWidth: '100px' }}>
                  {loggedInUser || "USER"}
                </span>
              </Link>
            </div>

            {/* UTILITY: Fullscreen */}
            <div className="d-none d-lg-inline-block ms-1 ms-xl-2">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                style={circleButtonStyle}
                className="btn btn-light"
                data-toggle="fullscreen"
                title="Fullscreen"
              >
                <i className="bx bx-fullscreen font-size-15" />
              </button>
            </div>

            {/* UTILITY: Logout */}
            <div className="ms-1 ms-xl-2">
              <Link
                to="/logout"
                style={circleButtonStyle}
                className="btn btn-light"
                title="Logout"
              >
                <i className="bx bx-log-out font-size-15" />
              </Link>
            </div>
          </div>
        </div>
      </header>
      <Modal isOpen={isSyncModalOpen} toggle={() => setIsSyncModalOpen(!isSyncModalOpen)} centered>
        <ModalHeader toggle={() => setIsSyncModalOpen(!isSyncModalOpen)}>
          <i className="bx bx-sync me-2 align-middle text-primary" />
          Manual Attendance Sync
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label style={{ fontWeight: 'bold' }}>Select Sync Mode</Label>
            <div>
              <FormGroup check inline>
                <Label check>
                  <Input
                    type="radio"
                    name="syncMode"
                    checked={syncMode === "range"}
                    onChange={() => { setSyncMode("range"); setSyncResult(null); }}
                  />{' '}
                  Date Range
                </Label>
              </FormGroup>
              <FormGroup check inline className="ms-3">
                <Label check>
                  <Input
                    type="radio"
                    name="syncMode"
                    checked={syncMode === "month"}
                    onChange={() => { setSyncMode("month"); setSyncResult(null); }}
                  />{' '}
                  Current Month
                </Label>
              </FormGroup>
              <FormGroup check inline className="ms-3">
                <Label check>
                  <Input
                    type="radio"
                    name="syncMode"
                    checked={syncMode === "all"}
                    onChange={() => { setSyncMode("all"); setSyncResult(null); }}
                  />{' '}
                  Sync All (Last 3 Months)
                </Label>
              </FormGroup>
            </div>
          </FormGroup>

          {syncMode === "range" && (
            <Row className="mt-3">
              <Col md={6}>
                <FormGroup>
                  <Label for="fromDate">From Date</Label>
                  <Input
                    type="date"
                    name="fromDate"
                    id="fromDate"
                    value={customFromDate}
                    onChange={(e) => { setCustomFromDate(e.target.value); setSyncResult(null); }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="toDate">To Date</Label>
                  <Input
                    type="date"
                    name="toDate"
                    id="toDate"
                    value={customToDate}
                    onChange={(e) => { setCustomToDate(e.target.value); setSyncResult(null); }}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}

          {syncStatus === "syncing" && (
            <div className="text-center my-4">
              <Spinner color="primary" className="mb-2" />
              <p className="text-muted mb-0">Syncing biometric logs in progress, please wait...</p>
            </div>
          )}

          {syncResult && (
            <div className={`alert ${syncResult.success ? 'alert-success' : 'alert-danger'} mt-3 mb-0`} role="alert">
              <h5 className="alert-heading">
                <i className={`bx ${syncResult.success ? 'bx-check-circle' : 'bx-x-circle'} me-1 align-middle`} />
                {syncResult.success ? 'Sync Completed' : 'Sync Failed'}
              </h5>
              {syncResult.success ? (
                <p className="mb-0">
                  Successfully synced biometric logs.<br />
                  <strong>Total Raw Logs:</strong> {syncResult.total}<br />
                  <strong>Processed/Updated Records:</strong> {syncResult.processed}<br />
                  <strong>Failed Records:</strong> {syncResult.failed}
                </p>
              ) : (
                <p className="mb-0">{syncResult.message}</p>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsSyncModalOpen(false)}>
            Close
          </Button>
          <Button
            color="primary"
            onClick={handleManualSync}
            disabled={syncStatus === "syncing"}
          >
            {syncStatus === "syncing" ? 'Syncing...' : 'Start Sync'}
          </Button>
        </ModalFooter>
      </Modal>

      <AdminApprovalsModal
        isOpen={isApprovalsModalOpen}
        toggle={() => setIsApprovalsModalOpen(!isApprovalsModalOpen)}
        onStatusChange={fetchPendingApprovalsCount}
      />
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
